/**
 * 施行後アンケート：質問グループクラス
 */
export default class AfterSurvey {
  constructor({ id, title, questionCount, answerCount, answerComplete, revision }) {
    this.id = id
    this.title = title
    this.questionCount = questionCount
    this.answerCount = answerCount
    this.answerComplete = answerComplete
    this.revision = revision
  }

  get isNotStarted() {
    return this.answerCount === 0
  }

  get isInProgress() {
    return (
      this.answerCount > 0 &&
      this.answerCount < this.questionCount
    )
  }

  get isDone() {
    return this.answerCount === this.questionCount
  }

  get isAnswerComplete() {
    return this.answerComplete === true
  }

  get isNotSend() {
    return (
      this.answerCount > 0 &&
      this.answerComplete === false
    )
  }
}
